var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"hide-default-footer":"","disable-sort":""},scopedSlots:_vm._u([{key:"item.value",fn:function({ item }){return [(typeof item.value === 'boolean')?_c('v-icon',[_vm._v(" "+_vm._s(item.value ? 'checkbox' : 'cancel')+" ")]):[_vm._v(" "+_vm._s(item.value)+" ")]]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }